import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { triggerRefresh } from '../redux/refreshSlice';
import { toast } from '../common_components/Toast/ToastUtils';
import { clearCache } from '../helper/cache';
export const useRefresh = (options = {}) => {
    const dispatch = useDispatch();
    const [isRefreshing, setIsRefreshing] = useState(false);
    const handleRefresh = useCallback(async (clientId, dateRanges, extraParams) => {
        if (!clientId || !dateRanges.length)
            return;
        setIsRefreshing(true);
        try {
            const resultAction = await dispatch(triggerRefresh({
                clientId,
                dateRange: dateRanges,
                ...extraParams // 👈 yaha inject ho jayega
            }));
            if (triggerRefresh.fulfilled.match(resultAction)) {
                const response = resultAction.payload;
                const failedNetworks = response?.data?.failed_networks || [];
                const uniqueFailedNetworks = [
                    ...new Map(failedNetworks.map((n) => [n.network, n.error])).entries()
                ];
                // Toast message
                if (uniqueFailedNetworks.length > 0) {
                    const formattedNames = uniqueFailedNetworks
                        .map(([name, err]) => {
                        let eStr = typeof err === 'string' ? err : err?.message;
                        if (eStr && eStr.toLowerCase().includes('time'))
                            eStr = 'Timeout';
                        return `${name.charAt(0).toUpperCase() + name.slice(1)}${eStr ? ` (${eStr})` : ''}`;
                    })
                        .join(', ');
                    toast.warning(`${options.moduleName || 'Data'} refresh completed.\nFailed to refresh: ${formattedNames}.`);
                }
                else {
                    toast.success('Client data refreshed successfully');
                }
                // ✅ Clear frontend cache before refetching so that we don't get stale data
                clearCache();
                // ✅ Re-fetch module data
                await options.onSuccess?.();
                return { success: true };
            }
            else {
                const errorMessage = resultAction.payload || (resultAction.error?.message) || 'Failed to refresh client data';
                toast.error(errorMessage);
                return { success: false, error: errorMessage };
            }
        }
        catch (error) {
            console.error('Refresh error:', error);
            const errorMessage = error?.message || 'Refresh failed. Please try again or contact support.';
            toast.error(errorMessage);
            return { success: false, error };
        }
        finally {
            setIsRefreshing(false);
        }
    }, [dispatch, options.onSuccess]);
    return {
        isRefreshing,
        handleRefresh
    };
};
